import { Box, CardMedia, Grid, Typography } from "@mui/material";

import iconUrl from "@/assets/icons/home/new-way/light-bulb.svg";
import imageUrlLg from "@/assets/images/home/new-way/metric-lg.png";
import imageMapSmUrl from "@/assets/images/home/new-way/metric-sm-map.png";
import useResponsive from "@/hooks/useResponsive";

import Label from "./Label";
import MetricList from "./MetricList";
import { imageMetricStyles, listWrapperStyles } from "./styles";

const Metrics = () => {
  const isMobile = useResponsive("down", "md");

  return (
    <Box
      bgcolor="white"
      borderRadius={3}
      py={{ xs: 2, md: 5, xl: 6.75 }}
      pl={{ xs: 2, md: 5, xl: 7.5 }}
      pr={{ xs: 2, md: 0, xl: 0 }}
      sx={{ boxShadow: "0 24px 48px -12px rgba(93,97,104,.1)" }}
    >
      <Grid container columnSpacing={{ xs: 0, md: 5, lg: 8, xl: 19.75 }}>
        <Grid item xs={12} md={6}>
          <Label label="Metrics" iconUrl={iconUrl} />

          <Typography
            variant="h3"
            fontSize={{ xs: "1.25rem", md: "2rem", lg: "2.5rem" }}
            mb={2}
          >
            Track the{" "}
            <Typography
              variant="h4"
              component="span"
              fontSize="inherit !important"
              fontWeight="inherit !important"
              fontFamily="inherit !important"
              color="text.accent"
            >
              right metrics{" "}
            </Typography>
            with zero setup
          </Typography>
          <Typography
            color="text.secondary"
            variant="body1"
            mb={{ xs: 3, lg: 6 }}
          >
            We've learned exactly what you need to track your vehicles so you
            know exactly what's wrong with your vehicles.
          </Typography>

          {!isMobile && <MetricList />}
        </Grid>

        <Grid item xs={12} md={6}>
          <Box display="flex" justifyContent="center" height={{ md: "100%" }}>
            {isMobile ? (
              <Box width="fit-content" position="relative">
                <Box sx={listWrapperStyles}>
                  <MetricList />
                </Box>
                <CardMedia
                  component="img"
                  loading="lazy"
                  image={imageMapSmUrl}
                  alt="image"
                  sx={imageMetricStyles}
                />
              </Box>
            ) : (
              <Box sx={{ width: "100%", height: "auto" }}>
                <CardMedia
                  component="img"
                  loading="lazy"
                  image={imageUrlLg}
                  alt="mao"
                  sx={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Metrics;
